export default "/images/home-bg@2x.jpg?116829dbe00b55cef79533827ce5efda";